/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */

export type DepartmentFunction = typeof DepartmentFunction[keyof typeof DepartmentFunction];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DepartmentFunction = {
  HeadOfDepartment: 'HeadOfDepartment',
  HeadOfWorkarea: 'HeadOfWorkarea',
  CanApproveAbsenceRequests: 'CanApproveAbsenceRequests',
} as const;
